import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import { startLoadingSpinner, stopLoadingSpinner } from "../../csf-ufc-pivotal/includes/utils";
import { clearSearchBtn } from '../includes/utils';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";

export function CsfPivotalFournisseurAddFormateur({
  accessToken,
  apiUrl,
  apiEnv,
  type,
  trainers,
  currentTrainers,
  listId,
  updateActiveTrainersList
}) {

  const [inputSearchValue, setInputSearchValue] = useState('');
  const [filteredTrainers, setFilteredTrainers] = useState([]);
  const [checkedTrainers, setCheckedTrainers] = useState('');
  const [multipleTrainers, setMultipleTrainers] = useState('');
  const [availableTrainers, setAvailableTrainers] = useState('');
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [isError, setIsError] = useState(false);

  const [slicedFilteredTrainers, setSlicedFilteredTrainers] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [startRow, setStartRow] = useState(1);
  const [offset, setOffset] = useState(5);
  const [total, setTotal] = useState(1);

  useEffect(() => {
    setCheckedTrainers(0);
    setMultipleTrainers(true);
    if (document.documentElement.lang === "fr") {
      setMultipleTrainers(false);
    }
  }, []);

  useEffect(() => {
    // Set filtered only after props are received
    setTotal(availableTrainers.length);
    if (availableTrainers && availableTrainers.length > 0) {
      setFilteredTrainers(availableTrainers);
      setSlicedFilteredTrainers(availableTrainers.slice((startRow - 1), (startRow + offset) - 1));
    }
  }, [availableTrainers]);

  useEffect(() => {
    if (trainers && trainers.length > 0 && currentTrainers) {
      setAvailableTrainers(getAvailableTrainers);
    }
  }, [trainers, currentTrainers]);

  useEffect(() => {
    setMultipleTrainers(hasMultiple);
  }, [checkedTrainers]);

  useEffect(() => {
    setSlicedFilteredTrainers(filteredTrainers.slice((startRow - 1), (startRow + offset) - 1));
    setIsSearch(false)
  }, [startRow, isSearch]);

  const handleSearchBtn = event => {
    if (event.key === 'Enter' || event.type === "click") {
      let filtered = availableTrainers;
      if (inputSearchValue !== '') {
        filtered = availableTrainers.filter((trainer) =>
          trainer.First_Name.toLowerCase().includes(inputSearchValue.toLowerCase()) ||
          trainer.Last_Name.toLowerCase().includes(inputSearchValue.toLowerCase())
        );
      }
      setFilteredTrainers(filtered);
      setTotal(filtered.length);
      setStartRow(1);
      setIsSearch(true);
    }
  };

  const handleSearchChange = (event) => {
    setInputSearchValue(event.target.value);
  };

  const resetSearch = () => {
    // Reset the checked inputs
    const inputs = document.querySelectorAll('#formateur-list-table input[type="checkbox"]:checked');
    if (inputs) {
      inputs.forEach(input => {
        input.click();
      })
    }

    setInputSearchValue('');
    setFilteredTrainers(availableTrainers);
    setTotal(availableTrainers.length);
    setStartRow(1);
    setIsSearch(true);
    setCheckedTrainers(0);
    setSelectedTrainers([]);
  }

  function handleCheckboxChange(event) {
    if (event.target.checked) {
      setCheckedTrainers(checkedTrainers + 1);
      const trainer = availableTrainers.find(item => item.Contact_Id === event.target.value);
      setSelectedTrainers([...selectedTrainers, trainer])
    } else {
      setCheckedTrainers(checkedTrainers - 1);
      const newArray = selectedTrainers.filter(item => item.Contact_Id !== event.target.value);
      setSelectedTrainers(newArray);
    }
  };

  const hasMultiple = () => {
    return checkedTrainers > 1 || (checkedTrainers === 0 && document.documentElement.lang === "en");
  };

  const getAvailableTrainers = () => {
    const otherArray = currentTrainers.map(({ Contact_Id }) => Contact_Id);
    const available = trainers.filter(trainer => !otherArray.includes(trainer.Contact_Id));
    return available;
  };

  function handleAddFormateurToList(e) {
    e.preventDefault();
    if (listId) {
      addUserDirectlyToExistingList();
    } else {
      updateActiveTrainersList(selectedTrainers);

      setTimeout(() => {
        // Wait for the update of the updated available trainer to reset modal on close
        $("[data-dismiss=modal]").trigger({ type: "click" });
      }, 500);
    }
  }

  function addUserDirectlyToExistingList() {
    startLoadingSpinner();
    const trainersToAdd = selectedTrainers.map(obj => ({
      CSF_EP_List_Contact_Bridge_Id: "",
      Contact_Id: obj.Contact_Id
    }));
    const requestData = {
      form: "CSF_EP_AddContactList_REST",
      recordId: listId,
      deltaData: { CSF_EP_List_Contact_Bridge__Secondary: trainersToAdd }
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, "_Espace_Partenaire")
      .then(response => {
        stopLoadingSpinner();
        if (response?.success) {
          $("[data-dismiss=modal]").trigger({ type: "click" });

          if (listId !== "") {
            window.location.reload();
          }
        } else {
          setIsError(true);
        }
      })
      .catch(error => {
        setIsError(true);
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch(){
    setInputSearchValue("");
    setFilteredTrainers(availableTrainers);
    setTotal(availableTrainers.length);
    setStartRow(1);
    setIsSearch(true);
  }

  return (
    <div className="modal fade" id="AddFormateur" tabIndex="-1" role="dialog"
      aria-labelledby="addFormateurLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="addFormateurLabel">
              {type === 'form' ? (
                window.Drupal.t('fournisseur.add.formateur.form.modal.title')
              ) : (
                window.Drupal.t('fournisseur.add.formateur.list.modal.title')
              )}
            </h2>
            <button type="button" className="close" data-dismiss="modal" onClick={resetSearch}
              aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            {isError === true && (
              <div className="alert alert-danger" role="alert"
                aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
            )}

            <div className="modal-list">
              <div className="search-container">
                <label htmlFor="addFormateurSearch"
                  className="sr-only">{window.Drupal.t('fournisseur.search.placeholder')}</label>
                <input type="search" id="addFormateurSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.search.placeholder')} />
                <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                  onClick={(e) => {
                    clearSearchBtn(e, setInputSearchValue)
                    retriggerEmptySearch();
                  }}
                >
                  <i className="icon icon-remove"></i>
                </button>
                <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                  title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                  <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                </button>
              </div>

              <div className="table-wrapper">
                <table id="formateur-list-table">
                  <caption id="formateur-list-caption"
                    className="sr-only">{window.Drupal.t('fournisseur.trainers.listing.table.title')}</caption>
                  <thead>
                    <tr>
                      <th width="50"></th>
                      <th width="20%">{window.Drupal.t('fournisseur.gestion.table.firstname')}</th>
                      <th width="30%">{window.Drupal.t('fournisseur.gestion.table.lastname')}</th>
                      <th>{window.Drupal.t('fournisseur.gestion.table.email')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {slicedFilteredTrainers.length === 0 ? (
                      <tr>
                        <td colSpan="6">
                          <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                        </td>
                      </tr>
                    ) : (
                      slicedFilteredTrainers.map((trainer) => (
                        <tr key={trainer.Contact_Id}>
                          <td className="p-0">
                            <div className="form-group special-padding">
                              <input id={trainer.Contact_Id} checked={selectedTrainers.some(item => item.Contact_Id === trainer.Contact_Id)} onChange={handleCheckboxChange} value={trainer.Contact_Id}
                                type="checkbox" name="formateurSelected" />
                              <label htmlFor={trainer.Contact_Id}
                                className="sr-only">{trainer.First_Name} {trainer.Last_Name}</label>
                            </div>
                          </td>
                          <td className="p-0 small">{trainer.First_Name}</td>
                          <td className="p-0 small">{trainer.Last_Name}</td>
                          <td className="p-0 small">{trainer.Contact_Email}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div className="modal-pagination">
              <CsfFournisseurPagination
                startRow={startRow}
                offset={offset}
                total={total}
                setStartRowFunction={setStartRow}
              />
            </div>

            <div className="buttons-wrapper">
              <button type="button" className="button btn-outlined btn-larger" onClick={resetSearch}
                data-dismiss="modal">{window.Drupal.t('fournisseur.cancel.btn')}</button>
              <button onClick={handleAddFormateurToList} type="button" className="button btn-filled btn-larger"
                id="modalSaveButton">
                {window.Drupal.t('fournisseur.creation_form.form.add')} {checkedTrainers} {window.Drupal.t('fournisseur.modal.btn.formateur')}{multipleTrainers ? 's' : ''}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurAddFormateur.propTypes = {
  accessToken: PropTypes.string,
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  type: PropTypes.string,
  trainers: PropTypes.array.isRequired,
  currentTrainers: PropTypes.array,
  listId: PropTypes.string,
  updateActiveTrainersList: PropTypes.func
};
